<template>
  <transition name="modal">
    <div class="modal__mask">
      <div class="modal__wrapper">
        <ModalHeader @double="$emit('double')"  
          @delete="$emit('delete')" 
          @close="$emit('close')" 
          :mode="mode" />

        <el-form :model="formData" ref="parentData">
          <section class="modal__body">
            <div class="modal__container">
                <section class="row_form">
                  <WestSideForm :exclude="excludes" 
                    :parentData="formData" 
                    :date="dateOption" 
                    :inputPosition="inputPosition" 
                    :forbiddenDays="forbiddenDates" 
                    :mode="mode"/>
                    
                  <EastSideForm :parentData="formData" 
                    :languages="formData.languages" />
                </section>
            </div>

            <section class="modal__container _mh--10">
              <el-button class="_mb-5" 
                @click="showRowIMG = true"
                round>Еще изображения
              </el-button>

              <transition name="slide-top2bottom">
                <section class="row_form other-img overflow-x" 
                  v-show="showRowIMG || (task && task.images && task.images.length)">

                  <section class="row_form" 
                    v-if="task && task.images && task.images.length">
                    <div v-for="img in oldIMG" :key="img.id"
                      class="old-other"
                      :style="`background: url(${host + img.file})`">

                      <div class="before">
                        <div class="btn_old-del">
                          <i class="el-icon-delete"
                            @click="handleRemoveOld(img.id)"></i>
                        </div>
                      </div>
                    </div>
                  </section>

                  <el-upload
                    action="#"
                    class="other-img__input"
                    :class="showRowIMG || (task && task.images && task.images.length) ? 'other-img__input_active' : ''"
                    :on-change="handleImage"
                    list-type="picture-card"
                    :limit="Number(4) - oldIMG.length"
                    :on-preview="handlePictureCardPreview"
                    :on-remove="handleRemove"
                    :multiple="true"
                    :auto-upload="false">
                      <i class="el-icon-plus"></i>
                  </el-upload>

                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>

                </section>
              </transition>
            </section>
          </section>
        
          <ModalFooter @close="$emit('close')" 
            :parentData="formData" :refs="this.$refs" 
            :mode="mode" />
        </el-form>

      </div>
    </div>
  </transition>
</template>

<script>
import ModalHeader from '@/components/modals/components/ModalHeader.vue'
import ModalFooter from '@/components/modals/components/ModalFooter.vue'
import WestSideForm from '@/components/modals/components/WestSideForm.vue'
import EastSideForm from '@/components/modals/components/EastSideForm.vue'
import moment from "moment";
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'AddTask',
  props: ['name', 'lang', 'mode', 'task', 
    'date', 'inputPosition', 'forbiddenDates', 
    'platform', 'exclude', 'otherIMGList'],
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,

      formData: {
        id: Date.now(),
        name: this.name,
        inputPosition: this.inputPosition,
        dateSpace: [],
        inputCountView: '0',
        inputButtonLink: '',
        tagName: '',
        vendorName: '',
        visible: [],
        inputTitleFirst: '',
        inputTextFirst: '',
        inputTxtBtnFirst: '',
        inputTitleSecond: '',
        inputTextSecond: '',
        inputTxtBtnSecond: '',
        inputTitleThird: '',
        inputTextThird: '',
        inputTxtBtnThird: '',
        backgroundSrc: '',
        backgroundSrcMobile: '',
        language_versions: [],
        languages: [],
        platformId: this.platform,
        images: [],
        img_id: '',
      },
      showRowIMG: false,
      excludes: {},
      oldIMG: '',
    }
  },
  components: {
    ModalHeader,
    ModalFooter,
    WestSideForm,
    EastSideForm,
  },
  computed: {
    ...mapGetters(['getLanguages', 'getPlatforms']),
    host: function() {
      return process.env.VUE_APP_BACKEND_HOST
    },
    dateOption: function() {
      if (this.mode === "new")
          return [moment(this.date.dmy, "D.M.YYYY").format("YYYY-MM-DD"), ""];
      else return this.formData.dateSpace;
    },
  },
  created: function() {
    if ( this.mode === 'edit' || this.mode === 'double' ) {
      this.formData = this.task;
      if (this.mode === "double")
        this.formData.mode = "double";
    } else {
      this.formData.visible = parseInt(this.$store.state.filters.filter.userGroup.id);
    }
    this.formData.languages = this.getPlatforms[this.platform].languages;
    Object.assign(this.excludes, this.exclude);
  },
  mounted() {
    if ( this.otherIMGList && this.otherIMGList.length ) {
      this.oldIMG = this.otherIMGList.slice();
    }
    if ( this.formData.mode === 'double' ) {
      if ( this.task.images && this.task.images.length ) {
        let arr = [];
        this.task.images.forEach(img => {
          this.oldIMG = this.task.images.slice();
          arr.push(img.id)
        })
        this.task.images_src = arr;
        this.formData = this.task;
      }
    }
  },
  methods: {
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleImage(file) {
      let isDuble = false;
      this.formData.images.forEach(img => {
        if ( img.uid === file.uid ) {
          isDuble = true;
          return;
        }
      })
      if ( !isDuble ) {
        this.formData.images.push(file);
      }
    },
    async handleRemoveOld(imgId) {
      this.formData.img_id = imgId;
      this.$store.dispatch("update_banner", this.formData);
      this.oldIMG = this.oldIMG.filter(obj => obj.id !== imgId);
    }
  }
}
</script>

<style lang="scss" scoped>
.modal__mask {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(52, 77, 100, 0.7);
  transition: opacity 0.3s ease;
}

.modal__wrapper {
  background-color: #FFFFFF;
  border-radius: 2px;
  transition: all 0.3s ease;
  width: 65%;
  max-width: 900px;
  max-height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

.modal__body { background: #F7F7F7; }
.modal__container {
  padding-left: 38px;
  padding-right: 29px;
}
.modal__label {
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -.5px;
  margin-bottom: 10px;
  color: #56565A;
}

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.row_form {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
}
._mb-5 { margin-bottom: 20px; }
.other-img { 
  height: 130px; 
  &__input { 
    height: 0;
    width: 200px;
    transition: height .3s ease; 

    &_active { height: 110px; }
  }
}

.old-other {
  width: 148px; 
  height: 110px; 
  background-size: cover !important; 
  margin: 0 5px;
  border-radius: 6px;
}

.slide-top2bottom-enter-active, 
.slide-top2bottom-leave-active {
  transition: height .3s ease;
}
.slide-top2bottom-enter, 
.slide-top2bottom-leave-to {
  height: 0;
}

.before {
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 100%;
  border-radius: 6px;
  background: rgba(0,0,0,.7);
  transition: opacity .3s ease;
  opacity: 0;
  cursor: pointer;

  &:hover { opacity: 1; }
}
.btn_old-del {
  color: #fff;
  border-radius: 50%;
  border: solid 1px #fff;
  background-color: rgba(0,0,0,.1);
  font-size: 22px;
  cursor: pointer;
  opacity: .7;
  padding: 5px 10px;
  transition: all .3s ease;

  &:hover { 
    opacity: 1;
    background-color: rgba(0,0,0,.5); 
  }
}

.overflow-x { overflow-x: auto; }
._mh--10 { margin: 0 -10px; }
</style>

<style lang='scss'>
.el-upload--picture-card {
  transition: all .5s ease;
}
.other-img__input {
  display: flex;
  & .el-upload--picture-card {
    opacity: 0;
    height: 0;
  }
  &_active .el-upload--picture-card {
    min-width: 200px;
    margin-left: 15px;
    animation: img-anim-show .3s ease both;
    animation-delay: .2s;
  }

  & .el-upload-list__item { 
    position: relative;
    margin: 0 5px;
  }

  & .el-upload-list {
    display: flex;
  }
}

@keyframes img-anim-show {
  from {    
    opacity: 0;
    height: 0 ;
  }
  to {
    opacity: 1;
    height: 110px;
  }
}
</style>
